import { ReactPortal, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {timer} from "rxjs";

import {Modal, ModalClose, ModalContentScroll, ModalFooter, ModalHeader, Overlay, Wrapper} from "#app/components/forms/ModalForm/styles";

import CloseIcon from "./images/close.svg";

interface ModalFormProps {
    modalVisible?: any;
    closeForm?: any;
    children?: any;
    header?: any;
    width?: any;
    height?: any;
    noScroll?: boolean;
    /** Уникальный id для крестика закрытия в шапке модалки (для автотестов) */
    closeId?: string;
    /**
     * По умолчанию true — на экранах ≤2100px ширина модалки принудительно
     * растягивается до 80vw (см. Modal в styles.ts), независимо от переданного
     * width и реального размера контента. Для модалок, которые должны просто
     * умещаться по ширине содержимого (см. TaskForm), это выключается.
     */
    allowRelativeWidthOnMedia?: boolean;
}

const ModalForm = ({
                       modalVisible,
                       closeForm,
                       children,
                       header = '',
                       width = 'auto',
                       height = '90%',
                       noScroll = false,
                       closeId,
                       allowRelativeWidthOnMedia = true,
                   }: ModalFormProps): null | ReactPortal => {
    const [overlayOpacity, setOverlayOpacity] = useState<string | number>(0);
    const [overlayTransform, setOverlayTransform] = useState<number | string>('0.1');

    useEffect(() => {
        setOverlayOpacity(1);
        setOverlayTransform(1);
    }, []);

    if (!modalVisible) return null;
    const modalElement: HTMLElement|null = document.getElementById('modal');
    if (!modalElement) return null;

    const handleClose = () => {
        timer(100).subscribe(() => {
            closeForm && closeForm();
        });
    }

    return ReactDOM.createPortal(
        <Overlay style={{opacity: overlayOpacity}}>
            <Wrapper style={{transform: `scale(${overlayTransform})`}}>
                <Modal width={width} height={height} allowRelativeWidthOnMedia={allowRelativeWidthOnMedia}>
                    <ModalHeader>
                        {header && <div>{header}</div>}
                        <ModalClose id={closeId} onClick={handleClose}>
                            <img src={CloseIcon as string} alt="Close"/>
                        </ModalClose>
                    </ModalHeader>
                    <ModalFooter>
                        {noScroll ? children : (
                            <ModalContentScroll>
                                {children}
                            </ModalContentScroll>
                        )}
                    </ModalFooter>
                </Modal>
            </Wrapper>
        </Overlay>,
        modalElement
    );
};

export default ModalForm;